"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = require("../Box");
var _Flex = require("../Flex");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _reactFocusOn = require("react-focus-on");
var _usePortal2 = require("../../utils/usePortal");
var _themeGet = require("@styled-system/theme-get");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Drawer = function Drawer(_ref) {
  var children = _ref.children,
    _ref$anchor = _ref.anchor,
    anchor = _ref$anchor === void 0 ? "right" : _ref$anchor,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? DEFAULT_DRAWER_Z_INDEX : _ref$zIndex,
    open = _ref.open,
    onClose = _ref.onClose;
  var _usePortal = (0, _usePortal2.usePortal)(),
    createPortal = _usePortal.createPortal;
  return createPortal( /*#__PURE__*/_react.default.createElement(Container, {
    zIndex: zIndex,
    anchor: anchor,
    style: {
      pointerEvents: open ? "auto" : "none",
      transform: open ? "translateX(0)" : "none"
    }
  }, /*#__PURE__*/_react.default.createElement(Focus, {
    onClickOutside: onClose,
    enabled: open,
    onEscapeKey: onClose
  }, /*#__PURE__*/_react.default.createElement(Content, {
    backgroundColor: "white100",
    height: "100%",
    width: ["100%", "auto"],
    overflowX: "hidden",
    overflowY: "scroll",
    anchor: anchor,
    zIndex: zIndex,
    transition: open ? "transform .6s cubic-bezier(0.190, 1.000, 0.220, 1.000)" // easeOutExpo
    : "transform 1s cubic-bezier(0.075, 0.820, 0.165, 1.000)" // easeOutCirc
    ,

    style: {
      transform: open ? "translateX(0)" : "translateX(".concat(anchor === "left" ? "-110%" : "110%", ")")
    }
  }, children)), /*#__PURE__*/_react.default.createElement(Overlay, {
    display: ["none", "flex"],
    onClick: onClose,
    "data-testid": "drawer-overlay",
    width: "inherit",
    style: {
      opacity: open ? 1 : 0
    }
  })));
};
exports.Drawer = Drawer;
var DEFAULT_DRAWER_Z_INDEX = 1;
var Content = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Drawer__Content",
  componentId: "ixq342-0"
})(["position:absolute;top:0;-webkit-overflow-scrolling:touch;", " ", ";"], function (props) {
  return (0, _styledComponents.css)(["transition:", ";"], props.transition);
}, function (props) {
  return (0, _styledComponents.css)(["", ""], props.anchor === "left" ? "left: 0;" : "right: 0;");
});
var Overlay = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Drawer__Overlay",
  componentId: "ixq342-1"
})(["height:100%;background:", ";transition:opacity 150ms linear 50ms;"], (0, _themeGet.themeGet)("effects.backdrop"));
var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Drawer__Container",
  componentId: "ixq342-2"
})(["top:0;left:0;width:100%;height:100%;", " position:fixed;", ""], _styledSystem.zIndex, function (props) {
  return (0, _styledComponents.css)(["flex-direction:", ";"], props.anchor === "left" ? "row" : "row-reverse");
});
var Focus = (0, _styledComponents.default)(_reactFocusOn.FocusOn).withConfig({
  displayName: "Drawer__Focus",
  componentId: "ixq342-3"
})(["height:100%;align-items:center;justify-content:center;"]);
//# sourceMappingURL=Drawer.js.map